import { EndpointConfigJSON, EndpointOverview, EndpointSetting, EntityDetailsWrapper } from 'components';
import RequestExplorerWrapper from 'components/Endpoints/RequestExplorer/RequestExplorerWrapper';
import { EndpointActionTypes, EndpointContext } from 'contexts/EndpointContext';
import { CACHE_FIRST, ENTITY_PATH_ID } from 'contracts/constants';
import type { EntityTab } from 'contracts/interfaces';
import type { FC } from 'react';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetEndpointQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

interface EndpointProps {
  isEditable: boolean;
}
const Endpoint: FC<EndpointProps> = ({ isEditable }) => {
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [ENTITY_PATH_ID]);
  const ctx = useContext(EndpointContext);

  const {
    loading: loadingEndpoint,
    data: endpointData,
    refetch
  } = useGetEndpointQuery({
    variables: { packageVersionUuid: params.versionUuid, uuid: params.entityId },
    ...CACHE_FIRST
  });

  useEffect(() => {
    if (endpointData?.getEndpoint.schema) {
      ctx?.dispatch({
        type: EndpointActionTypes.INIT_ENDPOINT_CONFIG,
        payload: {
          ...endpointData.getEndpoint.schema,
          uuid: endpointData.getEndpoint.uuid,
          packageVersionUuid: endpointData.getEndpoint.packageVersionUuid
        }
      });
    }
  }, [endpointData]);

  const tabs: EntityTab[] = [
    {
      label: 'Overview',
      isActive: true,
      content: <EndpointOverview params={params} isEditable={isEditable} />
    },
    {
      label: 'Settings',
      content: <EndpointSetting params={params} isEditable={isEditable} />
    },
    {
      label: 'JSON',
      content: <EndpointConfigJSON />
    },
    {
      label: 'Explorer',
      content: <RequestExplorerWrapper />
    }
  ];

  return <EntityDetailsWrapper key={`${params.versionUuid}_${params.entityId}`} tabs={tabs} />;
};

export default Endpoint;
